import { valuesEqual } from '~/utils/valuesEqual'

/**
 * Compares two snapshots of the same form-value shape and returns the field
 * names whose values actually differ, structurally for arrays/objects.
 */
export const findChangedFormFields = <TFormData extends object>(
  previous: TFormData,
  current: TFormData
): (keyof TFormData & string)[] => {
  const fieldNames = Object.keys(current) as (keyof TFormData & string)[]
  return fieldNames.filter((name) => !valuesEqual(previous[name], current[name]))
}
